import { ImageRB } from "../../components/imageRB/imageRB";
import { WhyChooseUsCard } from "../../components/whyChooseUsCard/whyChooseUsCard";
import { NavBar } from "../../components/layout/navbar/navbar";
import { TestimonyCard } from "../../components/testimonyCard/testimonyCard";
import { SplashScreen } from "../../components/splashScreen/splashScreen";
import HomeStyles from "./home.module.css";
import JourneyImage from "../../assets/images/journey-image.jpg";
import ExperiencedIcon from "../../assets/images/icons/experinced-icon-mh.svg";
import ExpertiseIcon from "../../assets/images/icons/expertise-icon-mh.svg";
import TransparencyIcon from "../../assets/images/icons/transparency-icon-mh.svg";
import ArrowRightUp from "../../assets/images/icons/arrow-right-up.svg";
import MusonHomesWebsiteVideo from "../../assets/videos/Mosun_website_video.webm";
import { Link, useNavigate } from "react-router-dom";
import SampleImg from "../../assets/images/bg/home-hero-section.png";
import React, { useRef, useCallback, useEffect, useState } from "react";
import { urlConfig } from "../../config/urlConfig";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import { whatWeDoData } from "../../mockData/whatWeDoData";

const Home = () => {
  const navigate = useNavigate();
  const sliderRef = useRef(null);
  const [videoBgUrl, setVideoBgUrl] = useState("");

  useEffect(() => {
    getBgVideo();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const handleBack = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const getBgVideo = async () => {
    const response = await fetch(
      `${urlConfig.BASE_URL}/api/platform-video?populate=*`,
      {
        method: "GET",
        headers: {
          "Content-Type": "Application/json",
        },
      }
    );

    if (!response.ok) {
      console.log("An error occured while trying to get all properties");
      return;
    }

    const data = await response.json();

    setVideoBgUrl(data.data.attributes.videoBackground.data.attributes.url);
  };

  return (
    <>
      <header className={HomeStyles.hero_section}>
        <NavBar />

        <div className="container h-100">
          <section className={HomeStyles.hero_text_section}>
            <div className={`row h-100`}>
              <div className={`col-lg-9  `}>
                <div className={HomeStyles.text_container}>
                  <h3 className={HomeStyles.title}>
                  Finding your Property, One Key at a Time
                  </h3>
                  <p className={HomeStyles.details}>
                    Welcome to Mosun Homes &amp; Realtors, your preferred resource for your real estate needs. We make finding your property worthwhile.
                  </p>
                </div>
              </div>
              <div className={`col-lg-3`}>
                <div className={HomeStyles.view_home_circle_container}>
                  <Link to="/properties" className={HomeStyles.img_container}>
                    <img src={ArrowRightUp} alt="View Homes" />
                  </Link>
                  <svg viewBox="0 0 100 100" width="100" height="100">
                    <defs>
                      <path
                        id="circle"
                        d="
        M 50, 50
        m -37, 0
        a 37,37 0 1,1 74,0
        a 37,37 0 1,1 -74,0"
                      />
                    </defs>
                    <text font-size="16">
                      <textPath xlinkHref="#circle">
                        &nbsp;&nbsp;View Properties&nbsp;&nbsp;.&nbsp;&nbsp;View
                        Properties&nbsp;&nbsp;.
                      </textPath>
                    </text>
                  </svg>
                </div>
              </div>
            </div>
          </section>
        </div>
      </header>

      <section className={HomeStyles.journey_section}>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 d-flex align-items-center">
              <section className={HomeStyles.text_section}>
                <h4 className={`${HomeStyles.title} section_header_title`}>
                  A little into our Journey
                </h4>
                <p className={`${HomeStyles.details} section_header_details`}>
                With over 10 years of team experience, we are a growing and innovative team with expertise in real estate investment advisory operating at the heart of Nigeria’s most dynamic city, Lagos. As a growing business rooted in integrity, innovation, and deep local expertise, we offer more than properties - we deliver value.
                </p>

                <button
                  className="btn mh_section_btn"
                  onClick={() => navigate("/about-us")}
                >
                  More about us
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.0248 4.94165L17.0832 9.99998L12.0248 15.0583"
                      stroke="#184D79"
                      stroke-width="1.3125"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2.91681 10H16.9418"
                      stroke="#184D79"
                      stroke-width="1.3125"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </section>
            </div>
            <div className="col-lg-6 d-flex justify-content-end">
              {/* <div className={HomeStyles.img_container}> */}
              <ImageRB
                imgSrc={JourneyImage}
                imgAlt={"A little journey about Mosun Homes & Realtor"}
                styleClass={"w-100"}
              />
              {/* </div> */}
            </div>
          </div>
        </div>
      </section>

      <section className={HomeStyles.why_section}>
        <div className="container">
          <div className={HomeStyles.header_section}>
            <h3 className={`${HomeStyles.title} section_header_title`}>
              Why Choose Us?
            </h3>
            <p className={`${HomeStyles.details} section_header_details`}>
              We know buying or selling a property can be tough, but we're here
              to ensure your satisfaction by making the process easy for you.
            </p>
          </div>

          <div className="row">
            <div className="col-lg-4 mb-4 mb-lg-0">
              <WhyChooseUsCard
                icon={ExperiencedIcon}
                title={"Personalised Experience"}
                details={
                  "We understand that every client has unique needs, and we'll work with you to create a tailored plan that meets your specific goals."
                }
              />
            </div>
            <div className="col-lg-4 mb-4 mb-lg-0">
              <WhyChooseUsCard
                icon={ExpertiseIcon}
                title={"Expertise"}
                details={
                  "Our team of agents has years of experience in the real estate industry and can help guide you through every step of the process."
                }
              />
            </div>
            <div className="col-lg-4 mb-4 mb-lg-0">
              <WhyChooseUsCard
                icon={TransparencyIcon}
                title={"Transparency"}
                details={
                  "We believe in being upfront and honest with our clients, and we'll always ensure honesty, ethics, and fairness in all our dealings with you."
                }
              />
            </div>
          </div>
        </div>
      </section>

      <Swiper
        ref={sliderRef}
        slidesPerView={1}
        spaceBetween={17}
        className="mySwiper wwd_my_swiper"
        modules={[Autoplay]}
        navigation={false}
        loop={true}
        autoplay={{
          delay: 25000,
          disableOnInteraction: false,
        }}
      >
        {whatWeDoData.map(({ id, photo, title, details }, index) => (
          <SwiperSlide>
            <section className={HomeStyles.slider_section}>
              <div className="container">
                <div className={`${HomeStyles.wwd_slider_container} row`}>
                  <div className={`${HomeStyles.wwd_slider_text} col-lg-8`}>
                    <span className={HomeStyles.number}>0{id}</span>

                    <div className={HomeStyles.header_section}>
                      <h4 className={HomeStyles.title}>What we do</h4>
                      <div className={HomeStyles.main_title}>{title}</div>

                      <p className={HomeStyles.details}>{details}</p>

                      <button className="btn mh_primary_w_btn me-auto mt-auto" onClick={() => navigate("/contact-us")}>
                        Contact us
                      </button>

                      <div className="nav_container">
                        <div
                          className={`${
                            index === 0 ? "disable" : ""
                          } prev_arrow`}
                          onClick={handleBack}
                        >
                          <svg
                            width="14"
                            height="26"
                            viewBox="0 0 14 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.5332 24.7666L0.799869 12.9999L12.5332 1.23327"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div
                          className={`${
                            index === whatWeDoData.length - 1 ? "disable" : ""
                          } next_arrow`}
                          onClick={handleNext}
                        >
                          <svg
                            width="14"
                            height="26"
                            viewBox="0 0 14 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.4668 24.7666L13.2001 12.9999L1.4668 1.23327"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${HomeStyles.wwd_slider_img} col-lg-4`}>
                    <div
                      className={HomeStyles.img_background}
                      style={{ backgroundImage: `url(${photo})` }}
                    ></div>
                  </div>
                </div>
              </div>
            </section>
          </SwiperSlide>
        ))}
      </Swiper>

      <section className={HomeStyles.testimony_section}>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 order-2 order-lg-1">
              <div className={HomeStyles.testimony_list_container}>
                <div className={HomeStyles.testimony_card}>
                  <TestimonyCard />
                </div>
                <div className={HomeStyles.testimony_card}>
                  <TestimonyCard />
                </div>
                <div className={HomeStyles.testimony_card}>
                  <TestimonyCard />
                </div>
                <div className={HomeStyles.testimony_card}>
                  <TestimonyCard />
                </div>
                <div className={HomeStyles.testimony_card}>
                  <TestimonyCard />
                </div>
              </div>
            </div>
            <div className="col-lg-6 d-flex align-items-center order-1 order-lg-2">
              <div className={HomeStyles.text_section}>
                <h3 className={`${HomeStyles.title} section_header_title`}>
                  Testimonials
                </h3>
                <p className={`${HomeStyles.details} section_header_details`}>
                  Don't just take our word for it. See what our satisfied
                  clients have to say about working with us
                </p>

                <button
                  className="btn mh_primary_b_btn"
                  onClick={() => navigate("/contact-us")}
                >
                  Contact us
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={HomeStyles.video_section}>
        {videoBgUrl && (
          <video autoPlay muted loop id={HomeStyles.website_video}>
            <source
              src={`${urlConfig.BASE_URL}${videoBgUrl}#t=0.1`}
              type="video/webm"
            />
            Your browser does not support the video tag.
          </video>
        )}

        <div className="container">
          <div className={HomeStyles.text_section}>
            <h3 className={HomeStyles.title}>
              Ready to take the first step towards finding your Property?{" "}
            </h3>
            <p className={HomeStyles.details}>
              Contact us today to schedule a consultation with one of our
              agents. We can't wait to help you make your next move!
            </p>
            <button
              className="btn mh_plain_btn"
              onClick={() => navigate("/contact-us")}
            >
              Contact us
            </button>
          </div>
        </div>
      </section>

      <section className={HomeStyles.contact_seection}>
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-lg-6 d-flex justify-content-center align-items-center">
              <div className={HomeStyles.follow_section}>
                <h4 className={HomeStyles.title}>Follow us</h4>
                <div className={HomeStyles.follow_container}>
                  {/* Instagram */}
                  <a
                  href="https://www.instagram.com/mh.realtors/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn mh_primary_b_btn" style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                  <svg
                    className={HomeStyles.instagram_icon}
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="white"
                  >
                    <path d="M7.75 2h8.5C19.55 2 22 4.45 22 7.75v8.5C22 19.55 19.55 22 16.25 22h-8.5C4.45 22 2 19.55 2 16.25v-8.5C2 4.45 4.45 2 7.75 2zm0 2C5.68 4 4 5.68 4 7.75v8.5C4 18.32 5.68 20 7.75 20h8.5c2.07 0 3.75-1.68 3.75-3.75v-8.5C20 5.68 18.32 4 16.25 4h-8.5zM12 7a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6zm4.5-.25a1 1 0 110 2 1 1 0 010-2z" />
                  </svg>
                  <span>Mosun Homes</span>
                </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6 d-flex justify-content-center align-items-center">
              <div className={HomeStyles.enquires_section}>
                <h4 className={HomeStyles.title}>
                  For more enquires contact us
                </h4>
                <button
                  className="btn mh_primary_b_btn"
                  onClick={() => navigate("/contact-us")}
                >
                  Contact us
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <SplashScreen />
    </>
  );
};

export default Home;
